module.exports={
	"Form": "PayItemViewManifest",
	"Scope": "PayItem-View",
	"Descriptors":
	{
		"PayItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "PayItem-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "PayItem-View-Identity",
				"Group": "PayItem-View-Identity"
			}
		},
		"PayItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "PayItem-View-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PayItem-View-Identity",
				"Group": "PayItem-View-Identity"
			}
		},
		"PayItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "PayItem-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.FunctionalClass":
		{
			"Name": "Functional Class",
			"Hash": "PayItem-View-FunctionalClass",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "PayItem-View-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.Amount":
		{
			"Name": "Amount",
			"Hash": "PayItem-View-Amount",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "PayItem-View-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "PayItem-View-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"PayItemDetails.Section":
		{
			"Name": "Section",
			"Hash": "PayItem-View-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.ExternalPayItemID":
		{
			"Name": "External Pay Item ID",
			"Hash": "PayItem-View-ExternalPayItemID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "PayItem-View-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "PayItem-View-Details",
				"Group": "PayItem-View-Details"
			}
		},
		"PayItemDetails.IDPayItem":
		{
			"Name": "IDPay Item",
			"Hash": "PayItem-View-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.GUIDPayItem":
		{
			"Name": "GUIDPay Item",
			"Hash": "PayItem-View-GUIDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PayItem-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PayItem-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PayItem-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		},
		"PayItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PayItem-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PayItem-View-DataAudit",
				"Group": "PayItem-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PayItem-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PayItem-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PayItem-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PayItem-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PayItem-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PayItem-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
